import { useAuthStore } from "@/stores/auth";
import type { AxiosError } from "axios";
import toasteventbus from "primevue/toasteventbus";

const lifeTime = 5000;

export function info(summary: string, detail: string, life: number = lifeTime) {
  toasteventbus.emit("add", { severity: "info", summary, detail, life, icon: "pi-info-circle" });
}

export function warn(summary: string, detail: string, life: number = lifeTime) {
  toasteventbus.emit("add", { severity: "warn", summary, detail, life, icon: "pi-exclamation-triangle" });
}

export function success(summary: string, detail: string, life: number = lifeTime) {
  toasteventbus.emit("add", { severity: "success", summary, detail, life, icon: "pi-check-circle" });
}

export function error(summary: string, detail: string, life: number = lifeTime) {
  toasteventbus.emit("add", { severity: "error", summary, detail, life, icon: "pi-times-circle" });
}

export function errorApi(error: AxiosError, summary: string = "Error Occurred", detail: string = error.message, life: number = lifeTime) {
  const authStore = useAuthStore();
  if (authStore.isSessionExpired()) {
    // Suppress error pop-ups on session expiration to prevent the user from being spammed by 401 errors if multiple requests were sent after
    // the session ended. The "sessionExpired" flag should be unset again on the login page forms in order to re-enable error messages.
    console.log("Error suppressed because of session expiration: " + error);
    return;
  }
  console.log(error);
  if (error.response) {
    toasteventbus.emit("add", { severity: "error", summary, detail, life, icon: "pi-times-circle" });
  } else if (error.request) {
    toasteventbus.emit("add", { severity: "error", summary: "Error Occurred", detail: "API not responding", life, icon: "pi-times-circle" });
  } else {
    toasteventbus.emit("add", {
      severity: "error",
      summary: "Error Occurred While Creating Request",
      detail: error.message,
      life,
      icon: "pi-times-circle",
    });
  }
}
